import React, { useEffect, useState } from 'react'
import { DoubleCustomBreadCrumbs } from '../../components/CustomBreadcrumbs'
import { useTranslation } from 'react-i18next'
import Navbar from '../../components/Navbar'
import Footer from './../../components/Footer';
import ic_search from "../../assets/images/icons/search_24px_white.svg"
import { CustomPagination } from '../../components/StyledComponents';
import { BlogData } from './BlogData';
import BlogCard from './BlogCard';

const Blog = () => {
  const { t } = useTranslation()

  const blogData = BlogData()

  const itemsPerPage = 6;

  const PAGE_STORAGE_KEY = 'currentPage';

  const [currentPage, setCurrentPage] = useState(
    () => {
      const storedPage = localStorage.getItem('currentPage');
      if (storedPage) {
        const { page, expiry } = JSON.parse(storedPage);
        if (expiry && new Date(expiry) > new Date()) {
          return parseInt(page, 10);
        }
      }
      return 1;
      // return storedPage ? parseInt(storedPage, 10) : 1;
    }
  );

  useEffect(() => {
    // localStorage.setItem('currentPage', currentPage)
    const expiryTime = new Date()
    expiryTime.setMinutes(expiryTime.getMinutes() + 10); // Set expiry time to 10 minutes from now

    localStorage.setItem(
      PAGE_STORAGE_KEY,
      JSON.stringify({
        page: currentPage,
        expiry: expiryTime.toISOString(), // Store expiry time in ISO format
      })
    );

    // Set a timeout to remove the item after 10 minutes
    const timeoutId = setTimeout(() => {
      localStorage.removeItem(PAGE_STORAGE_KEY);
    }, 10 * 60 * 1000); // 10 minutes in milliseconds

    // Clear the timeout on component unmount
    return () => clearTimeout(timeoutId);
  }, [currentPage])

  const [searchQuery, setSearchQuery] = useState('');


  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  };

  const filteredData = blogData.filter((item) =>
    item.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
    item.content.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  const currentItems = filteredData.slice(startIndex, endIndex);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const [maxPageCount, setMaxPageCount] = useState(Math.ceil(filteredData.length / itemsPerPage));

  useEffect(() => {
    setMaxPageCount(Math.ceil(filteredData.length / itemsPerPage));
  }, [filteredData, itemsPerPage]);

  const handlePageInputChange = (e) => {
    let enteredValue = parseInt(e.target.value);
    if (enteredValue > maxPageCount) {
      enteredValue = maxPageCount;
    }
    if (enteredValue <= 0) {
      enteredValue = 1;
    }
    setCurrentPage(enteredValue);

  };

  // const handlePageInputKeyDown = (e) => {
  //   if (e.key === 'Backspace' && e.target.value === null) {
  //     setCurrentPage(1)
  //   }
  // };

  return (
    <div className='blog bg-primary'>
      <Navbar />
      <div className='container-fluid blog-header pb-50'>
        <div className='container'>
          <div className='col-sm-12 pt-150'>
            <div className='font-weight-bold text-center font-64 blog-header-title'>{t('blog.title')}</div>
            <div className='col-sm-12'>
              <div className='underline-orange'></div>
            </div>
          </div>
          <div className='col-sm-12 flex justify-center pt-50 px-0'>
            <DoubleCustomBreadCrumbs currentPage={t('bread-crumbs.blog')} />
          </div>
        </div>
      </div>
      <div className='blog-content container'>
        <div className="row">
          <div className='col-sm-12'>
            <input type="text" name='blog-search' className='blog-search-bar' placeholder={t('blog.i-want-to-read-about')} onChange={handleSearchChange} value={searchQuery} />
            <img src={ic_search} alt="" className='blog-search-icon' />
          </div>
          <div className="col-sm-12 pt-50">
            <p className='font-weight-semi-bold font-40 text-white'>{t('blog.all-posts')}</p>
            <div className='flex flex-wrap row'>
              {currentItems.length !== 0
                ?
                currentItems.map((item, index) => (
                  <div className='col-xl-4 col-md-6' key={index}>
                    <BlogCard searchQuery={searchQuery} item={item} />
                  </div>
                ))
                :
                <div className="col-sm-12 text-center">
                  <p className='text-white font-weight-semi-bold justify-center font-32 pt-50'>{t('blog.cant-find-result')} '<span className='text-primary-orange'>{searchQuery}</span>'</p>
                </div>
              }

            </div>
            <div className='pt-50 pb-lg-50 flex justify-center align-center relative pb-100'>
              <CustomPagination
                count={Math.ceil(filteredData.length / itemsPerPage)}
                page={currentPage}
                onChange={handlePageChange}
                boundaryCount={0}
                siblingCount={1}
              />
              <div className='page-of-page'>

                <p className='text-gray' >
                  {t('blog.page')}
                  <span>
                    <input type='number' value={currentPage}
                      onChange={handlePageInputChange} />
                  </span>
                  {t('blog.of')} {Math.ceil(filteredData.length / itemsPerPage)}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default Blog